import { combineReducers } from 'redux';
import authorizeReducer from './authorizeReducer';
import userReducer from './userReducer';

export default combineReducers({ 
  authorizeReducer,
  userReducer,
});
